import React from "react";

export default function ConfirmationModal({
  open,
  title = "Are you sure?",
  message,
  onCancel,
  onConfirm,
  confirmText = "Delete",
  cancelText = "Cancel",
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center px-3 bg-black bg-opacity-60">
      <div className="bg-[#181818] rounded shadow-lg p-4 md:p-8 min-w-[350px] max-w-xl">
        <h2 className="text-xl font-bold mb-2">{title}</h2>
        <p className="mb-6 text-gray-300">{message}</p>
        <div className="flex justify-end gap-4">
          <button
            className="px-6 py-2 border border-gray-500 rounded bg-black text-white hover:bg-gray-800"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className="px-6 py-2 rounded bg-red-500 text-white font-semibold hover:bg-red-600"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}